export default __webpack_public_path__ + "static/media/marine-application.a26af3fb.png";